import { BANK_CHARGES_NOTICE } from '../invest-v2/invest-v2-share-order'
import React, { useEffect, useState } from 'react'
import './payment.scss'
import {
  H2,
  Span,
  Anchor,
  H4,
  Image,
  Line,
  P,
  Button,
  PrintIcon,
  PendingIcon,
  DownloadIcon,
  ApprovedIcon,
} from '../../lib/components'
import { useNavigate } from 'react-router-dom'
import { displayDollar } from '../../lib/utils/helpers'
import { PLATFORM_FEE_CURRENCY } from './constants'
import { PaymentSummaryProps } from '../../lib/types'
import { investServices } from '../../services'
import { useDispatch, useSelector } from 'react-redux'
import { InvestmentFeeSummary } from '../../services/types'
import { RootState } from '../../store'
import { renderFeeRow } from './DisplayFee'
import { dispatchDealingChargesWaivedBannerIfNeeded } from './dealing-charges-waived-banner'

const PaymentSummary = ({
  handlePrintPaymentSummary,
  opportunity,
  investmentData,
  handleShowContactUsModal,
  handleFilePreview,
}: PaymentSummaryProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { authToken } = useSelector((state: RootState) => state.investor)
  const [investmentFeeSummary, setinvestmentFeeSummary] = useState<InvestmentFeeSummary>()
  const SummaryData = [
    {
      title: 'The Credibila Team will review the investment request submitted. ',
      subTitle:
        'The Team will now review the subscription agreement document and payment swift copy uploaded by you. You will receive an email once the investment documents are reviewed and approved by the Credibila Team.',
    },
    {
      title:
        'Fund allocation is subject to the allocation decision of the fund manager and the availability of allocation.',
      subTitle:
        "The investment approval does not mean the fund units have been allocated to you. It is subject to the fund manager's discretion and the availability of fund units.",
    },
    {
      title: (
        <>
          In the case of the fund units are not allocated, contact the{' '}
          <span onClick={() => handleShowContactUsModal()}>
            {' '}
            <Anchor text='Credibila Team' href='' variant='basic-anchor' />{' '}
          </span>{' '}
          .
        </>
      ),
      subTitle:
        'The invested amount will be returned to you in the bank account mentioned in the swift copy uploaded within 10-12 business days.',
    },
  ]

  const opportunityId = opportunity?.id
  // Share-priced orders carry cents (e.g. a 5.55% fee), so keep them visible.
  const showCents = Boolean(investmentData?.shares)
  const investmentAmount = investmentData?.amount
  const investmentId = investmentData?.id

  useEffect(() => {
    const getInvestmentFeeSummary = async () => {
      const opportunityId = opportunity?.id
      if (!opportunityId || !investmentId) return
      const data = await investServices.getInvestmentFeeSummary(
        {
          opportunityId,
          investmentAmount: (Number(investmentAmount) / 100).toString(),
          investmentId,
        },
        {
          Authorization: authToken ? authToken : '',
        },
      )
      dispatchDealingChargesWaivedBannerIfNeeded(dispatch, data)
      setinvestmentFeeSummary(data)
    }
    getInvestmentFeeSummary()
  }, [opportunityId, investmentId])
  console.log('investmentFeeSummary', investmentFeeSummary)
  return (
    <>
      <div className='payment-summary-heading-container'>
        <H2 text='Investment summary' />
        <div>
          <Span text={'Investment process for'} />
          <Anchor
            classes={['invest-header-project-title']}
            text={opportunity.projectName}
            href={`/opportunity/${opportunity?.projectSlug}/${opportunity?.id}`}
            variant='basic-anchor'
          />
        </div>
      </div>
      <div className='payment-summary-wrapper'>
        <div className='payment-summary-wrapper-left'>
          <span> Further instructions </span>
          <div className='further-instruction-container'>
            {SummaryData &&
              SummaryData.map((obj, index) => {
                return (
                  <div key={obj.subTitle} className='further-instruction-row'>
                    <div className='further-instruction-column-left'>{index + 1}</div>
                    <div className='further-instruction-column-right'>
                      <H4 text={obj.title} />
                      <P variant='default-gray' text={obj.subTitle} />
                    </div>
                  </div>
                )
              })}
          </div>
          <div className='button-container'>
            <Button
              text='Go to dashboard'
              handleClick={() => {
                navigate('/dashboard')
              }}
              variant='primary-btn'
            />
            <Button
              text='View more opportunities'
              handleClick={() => {
                navigate('/opportunities')
              }}
              variant='basic-btn'
            />
          </div>
        </div>
        <div className='payment-summary-wrapper-right'>
          <div className='payment-company-card'>
            <span className='summary-label'> {'Summary'} </span>
            <div className='company-image-container'>
              <Image source={opportunity.projectCover} radius='r8' variant='round' />
              <span className='company-name'> {opportunity.projectName} </span>
            </div>
            <div className='property-container'>
              <P variant='default-gray' textSize='small' text={opportunity.projectSummary} />
              <div className='property-row'>
                <span className='property-column-left'>{'Investment amount:'}</span>
                <span className='property-column-right'>
                  {displayDollar(
                    ((investmentFeeSummary?.investmentAmount || 0) * 100).toString(),
                    opportunity.currencyCode,
                    2,
                    true,
                    showCents,
                  )}
                </span>
              </div>
              <div className='property-row'>
                <span className='property-column-left'>
                  (This will be invested in {opportunity?.projectName})
                </span>
              </div>
              <Line />
              <div className='property-row'>
                <span className='property-column-left bold'>Fees</span>
              </div>
              {investmentFeeSummary?.fees?.length ? (
                <>
                  {investmentFeeSummary.fees
                    .filter((fee) => {
                      return fee.name !== 'platformFee'
                    })
                    .map((fee) => {
                      return renderFeeRow(fee, opportunity.currencyCode || '', showCents)
                    })}
                </>
              ) : null}
              <div className='property-row'>
                <span className='property-column-left'>Dealing Charges:</span>
                <span className='property-column-right'>
                  {displayDollar(
                    ((investmentFeeSummary?.fees[0].appliedAmount || 0) * 100).toString(),
                    PLATFORM_FEE_CURRENCY,
                  )}
                </span>
              </div>
              <Line />
              <div className='property-row'>
                <span className='property-column-left' data-testid='total-amount-transfered-text'>
                  Total Amount Transferred:
                </span>
                <span className='property-column-right' data-testid='total-amount-transfered-value'>
                  {displayDollar(
                    ((investmentFeeSummary?.totalAmountTransferred || 0) * 100).toString(),
                    opportunity.currencyCode,
                    2,
                    true,
                    showCents,
                  )}
                </span>
              </div>
              {investmentData?.shares ? (
                <p className='iv2-bank-purpose-note' data-testid='bank-charges-notice'>
                  {BANK_CHARGES_NOTICE}
                </p>
              ) : null}
            </div>
            {!investmentData?.fundAllocation && (
              <div className='payment-warning-container'>
                <PendingIcon classes={['info-icon']} width='24' height='24' />
                The investment is subject to allocation decision of the fund manager and
                availability of allocation
              </div>
            )}
            {investmentData?.fundAllocation && (
              <div className='payment-success-container'>
                <ApprovedIcon type='success' classes={['info-icon']} width='24' height='24' />
                Congratulations, Your payment has approved. You have allocated the Fund Allocation
                Document.
              </div>
            )}
          </div>
          <Button
            iconVariant='left'
            IconComponent={<PrintIcon classes={['mr-8']} />}
            text='Print summary'
            handleClick={handlePrintPaymentSummary}
            variant='basic-btn'
          />
          {investmentData?.fundAllocation && (
            <Button
              iconVariant='left'
              IconComponent={<DownloadIcon classes={['mr-8']} />}
              text='Fund allocation'
              buttonType='submit'
              handleClick={async () => {
                if (investmentData?.fundAllocation) {
                  const url = await handleFilePreview(investmentData?.fundAllocation)
                  url && window.open(url, '_blank')
                }
              }}
              variant='basic-btn'
            />
          )}
        </div>
      </div>
    </>
  )
}

export { PaymentSummary }
